import { render, staticRenderFns } from "./bsp-file-upload.vue?vue&type=template&id=2aea8e54&scoped=true&"
import script from "./bsp-file-upload.vue?vue&type=script&lang=js&"
export * from "./bsp-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./bsp-file-upload.vue?vue&type=style&index=0&id=2aea8e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea8e54",
  null
  
)

export default component.exports